import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { logger } from '../../datadog';
import { UserType } from '../../types';
import {
  DataChannelMessageType,
  DataChannelSessionIntentionPromptAcknowledgedMessage,
  useSendMessage,
} from '../../video-sdk';

export function useSendSessionIntentionPromptAcknowledgedCallback() {
  const { patientShortId } = useParams();
  const sendMessage = useSendMessage();

  return useCallback(async () => {
    logger.info('Sent data channel message', {
      messageType: DataChannelMessageType.SESSION_INTENTION_PROMPT_ACKNOWLEDGED,
      sender: 'client',
    });

    const message: DataChannelSessionIntentionPromptAcknowledgedMessage = {
      type: DataChannelMessageType.SESSION_INTENTION_PROMPT_ACKNOWLEDGED,
      sender: {
        entityId: patientShortId ?? '',
        entityType: UserType.CLIENT,
      },
      prompt: {
        version: 1,
        response: 'COMPLETED',
        acknowledgedAt: new Date().toISOString(),
      },
    };

    await sendMessage(message);
  }, [sendMessage, patientShortId]);
}
